import { ThemeUICSSObject } from 'theme-ui';
import { primary } from './primary';
/* IMPORT HERE */

export const tooltips: ThemeUICSSObject = {
  primary,
  /* PREPEND HERE */
};
